// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Expired_wrapper__3XniE","container":"Expired_container__1R6NH","img":"Expired_img__2fawC","text":"Expired_text__1pwuB"};